export const CONTACT_INFO = {
  email: "info@omidib.com",
  officeAddress:
    "تهران، خیابان سهروردی شمالی، خیابان خرمشهر، کوچه شکوه، پلاک ۲",
  postalCode: "۱۵۵۷۷۴۶۵۱۱",
  fundsPhone: "021-54906",
  fundsPhoneHref: "tel:+982154906",
  officePhone: "021-88536880",
  officePhoneHref: "tel:+982188536880",
  fax: "021-88515695",
  hours: ["شنبه تا سه‌شنبه: ۷:۳۰ تا ۱۶:۳۰", "چهارشنبه: ۷:۳۰ تا ۱۵:۳۰"],
  mapEmbedSrc: "https://maps.google.com/maps?q=35.736,51.441&z=16&output=embed",
  mapHref:
    "https://neshan.org/maps/routing/car/origin/35.735930,51.440806/destination/35.736,51.441",
  socials: [
    {
      label: "تلگرام",
      key: "telegram",
      href: "https://t.me/omidinvestmentbank",
      slug: "OMIDINVESTMENTBANK",
    },
    {
      label: "اینستاگرام",
      key: "instagram",
      href: "https://www.instagram.com/omid.investmentbank?igsh=MXA1ejVjcjQ3OWM5bQ==",
      slug: "OMID.INVESTMENTBANK",
    },
    {
      label: "بله",
      key: "ble",
      href: "https://ble.ir/omidinvestmentbank",
      slug: "OMIDINVESTMENTBANK",
    },
    {
      label: "ایتا",
      key: "eitaa",
      href: "https://eitaa.com/omidinvestmentbank",
      slug: "OMIDINVESTMENTBANK",
    },
    {
      label: "لینکدین",
      key: "linkedin",
      href: "https://www.linkedin.com/company/omidinvestmentbank/",
      slug: "OMIDINVESTMENTBANK",
    },
  ],
} as const;
